export default __webpack_public_path__ + "static/media/subtle.2c3196ab.png";